import React from 'react';

const Terms = () => (
  <div className="referral__terms--container">
    <h4>*Terms & Conditions</h4>
    <p>Active: December 1, 2018</p>
    <p>How to get $50 bonus:</p>
    <ol>
      <li>
        Get a friend to sign up using your referral code. You can either share the link with them to direct them to the
        sign up page where your code will automatically be added, or you can share the code with your friend so they can
        put in the code manually in the application form.
      </li>
      <li>Your friend must be eligible for Uber and Autzu to have an active Autzu account.</li>
      <li>Our system will check when your friend completes 20 hours with Autzu.</li>
      <li>After that happens, we will automatically credit both you and your friend $50 to your accounts.</li>
    </ol>
    <p>Eligibility:</p>
    <ul>
      <li>Referring user must have an account in Autzu</li>
      <li>Referred user must complete 20 total hours with Autzu</li>
    </ul>
  </div>
);

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Referral/Terms.js